<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import BaseModal from "@/components/global-themed/BaseModal.vue";
import {ref} from "vue";
import VideoIframe from "@/components/video/VideoIframe.vue";

const open = ref(false);

defineProps({
  videoUrl: {
    required: true,
    type: String,
  },
});

</script>

<template>
  <DefaultButton
    variant="primary-inverted"
    @click.prevent="open = true"
  >
    <svg-vue
      icon="icons/help"
      class="tw-w-6 tw-h-6 tw-mr-3"
    />
    <span class="tw-font-bold">Help</span>
  </DefaultButton>

  <Teleport to=".tailwind">
    <BaseModal
      v-if="open"
      @close="open = false"
    >
      <div class="tw-px-8 tw-pb-8 tw-flex tw-flex-col tw-gap-8 tw-justify-center">
        <h2 class="tw-text-2xl tw-text-center tw-font-medium">
          Tutorial Video
        </h2>
        <VideoIframe
          :video-url="videoUrl"
          class="tw-w-full tw-h-[50vh]"
        />
        <DefaultButton
          class="tw-w-auto tw-mx-auto"
          @click="open = false"
        >
          I've Finished Watching the Video
        </DefaultButton>
      </div>
    </BaseModal>
  </Teleport>
</template>
